import { render } from "./OptoutFinal.vue?vue&type=template&id=3dca945c"
import script from "./OptoutFinal.vue?vue&type=script&lang=js"
export * from "./OptoutFinal.vue?vue&type=script&lang=js"

import "./OptoutFinal.vue?vue&type=style&index=0&id=3dca945c&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__